import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { WithApp } from 'contexts/appContext';
import moment from 'moment';

export default WithApp(function ModalLinealitiesClorox(props) {
  const linealidad = props.model;
  const periodo = moment(linealidad.valueSearch?.Periodo).format('YYYY-MM');
  const [dataChanging, setDataChanging] = useState({});

  function handleChange(field, value) {
    setDataChanging((prev) => ({ ...prev, [field]: value }));
  }

  useEffect(() => {
    if (linealidad.open) {
      setDataChanging({});
    }
  }, [linealidad.open]);

  return (
    <>
      <Modal
        title={`Linealidad Clorox`}
        model={linealidad}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity="sale/clorox-linearities"
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={periodo || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <TextField
          label="Descripción"
          fullWidth
          type="text"
          name="description"
          margin="normal"
          defaultValue={!!linealidad ? linealidad.description : ''}
          onChange={(e) => handleChange('description', e.target.value)}
          required
        />
        <TextField
          label="días"
          fullWidth
          type="text"
          name="days"
          margin="normal"
          defaultValue={!!linealidad ? linealidad.days : ''}
          onChange={(e) => handleChange('days', e.target.value)}
          required
        />
        <TextField
          label="Cuota"
          fullWidth
          type="number"
          name="quota"
          margin="normal"
          defaultValue={!!linealidad ? linealidad.quota : ''}
          onChange={(e) => handleChange('quota', e.target.value)}
          required
        />
      </Modal>
    </>
  );
});
